import Vue from 'vue'
import Index from './index.vue'

const CanReloadConfirmBox = Vue.extend(Index)

const CanReloadConfirm = () => {
  const instance = new CanReloadConfirmBox().$mount()

  if (!document.body.querySelector('.el-dialog.can-reload-dialog')) {
    document.body.appendChild(instance.$el)
  }

  return instance.open()
}

export default CanReloadConfirm
